import { WIZ_NUMERIC_CONSTANT } from '../models/enums';
import { WizCoreTranslationManager as WizTranslationManager } from '../services/wiz-translation.manager';

import numeral from 'numeral';
import { WizNumberFormatter } from './wiz-number.formatter';

/**
 * Utility class for number operations
 */
export class WizNumberUtils {

  // pour injection depuis la lib component
  public static tradInstance: WizTranslationManager = null;

  /** Application decimal separator */
  public static get decimalSeparator(): string {
    let res:string ='.';
    res= this.tradInstance.translateKey(WIZ_NUMERIC_CONSTANT.DECIMAL_SEPARATOR, null, res);
    return res;
  };

  /** Application thousand separator */
  public static get thousandSeparator(): string {
    let res:string =' ';
    res= this.tradInstance.translateKey(WIZ_NUMERIC_CONSTANT.THOUSAND_SEPARATOR, null, res);
    return res;
  };


  /** Application default decimal number */
  public static get nbDecimal(): number {
    let res:string ='2';
    res= this.tradInstance.translateKey(WIZ_NUMERIC_CONSTANT.NB_DECIMAL, null, res);
    return Number(res);
  };

  /**
   * Number format
   * @param pValue Number
   * @param precision Decimal number
   */
  public static formatNumber(pValue: number, precision?: number,  thousandSeparator: string = null, decimalSeparator: string = null): string {
    // TO_VALIDATE: ADD
    // Check pValue
    if(!this.isValidNumber(pValue)){
      return null;
    }

    if (isNaN(precision)) {
      precision = this.nbDecimal;
    }
    if(thousandSeparator === null){
      thousandSeparator = this.thousandSeparator;
    }
    if(!decimalSeparator){
      decimalSeparator = this.decimalSeparator;
    }
    const res: string = WizNumberFormatter.formatNumber(pValue, precision, thousandSeparator, decimalSeparator);
    // console.log('formatNumber', pValue, precision, res);
    return res;
  }

  /**
   * Integer format
   * @param pValue Number
   * @param precision Decimal number
   */
  public static formatInteger(pValue: number): string {
    return this.formatNumber(pValue, 0);
  }


  /**
   * convert à number on string type to real number
   * @param pValue the value to convert
   */
  public static parseNumber(pValue: string): number {
    if (pValue == null) {
      return 0;
    }
    return numeral(pValue).value();
  }

  /** Format un number qui ne respecte pas le format en un number qui le respecte */
  public static numberToNumber(pValue): number {
    return !isNaN(pValue) ? this.parseNumber(pValue) : NaN;
  }

  /**
   * format un string en number
   */
  public static formatStringAsNumber(pValue: string) {
    if (pValue === null || pValue.length === 0) {
      return NaN;
    }
    return numeral(pValue).value();
  }

  /**
   * verifie que 2 nombre sont égaux
   * @param n1 le premier nombre
   * @param n2 le second nombre
   */
  public static numberEquals(n1: number, n2: number) {
    return isNaN(n1) && isNaN(n2) ? true : n1 === n2;
  }

  /**
   * conversion d'un nombre au format BDD (décimale=.),
   * mais en string... pour retour number sur editionPanel
   */
  public static toRealNumber(pValue: string) {
    if(!pValue || pValue === undefined){
      return null;
    }
    let res = '';
    res = pValue.replace(',', '.');
    return res;
  }


  /**
   * Vérification que le number est valide
   * @param number : number à valider
   * @return boolean
   */
  public static isValidNumber(number: number) : boolean {
    // vérification not number / null / undefined
    return !isNaN(number) && String(number) !== '' && number !== null && number !== undefined;
  }


  /**
   * convestion d'une chaine de caractère de chiffre en nombre decimal
   * @param value : value à convertir
   * @returns, la valeur correspondante à value en nombre
   */
  public static wizParseFloat(value: string): number {
    if(!!value){
      let result;
      if(value.startsWith('-') && value.length > 1){
        result = '-' + parseFloat(this.toRealNumber(value.substring(1))); 
      } else {
        result = parseFloat(this.toRealNumber(value));
      }
      return result;
    }
    return null;
  }
}
